// extracted by mini-css-extract-plugin
export default {"imageContainer":"GameImage_imageContainer__WYbQn","white":"GameImage_white__-VSsl"};